import {
  StyledButton,
  StyledButtonText,
  StyledImg,
} from "Components/Error/ErrorStyles";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { RecentActivities } from "Components/Shared/Icons";
import { UnstyledLink } from "Components/Shared/Routes/UnstyledLink";
import * as React from "react";
import { Resources, useResource } from "Translations/Resources";

export const Error404Page: React.FunctionComponent = _ => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout
      title={t(Resources.Errors.Error404.Title)}
      subTitle={t(Resources.Errors.Error404.Subtitle)}
      image={
        <StyledImg>
          <RecentActivities />
        </StyledImg>
      }
      btn={
        <UnstyledLink to="/">
          <StyledButton>
            <StyledButtonText>{t(Resources.Dashboard.Title)}</StyledButtonText>
          </StyledButton>
        </UnstyledLink>
      }
    ></UnauthenticatedLayout>
  );
};
